import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.cartAddressManagement || initialState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectPickupAddress = createSelector(
  [selectDomain],
  (state) => state.pickupAddress
);

export const selectBillingAddress = createSelector(
  [selectDomain],
  (state) => state.billingAddress
);

export const selectPickupAddressCount = createSelector(
  [selectDomain],
  (state) => state.pickupAddressCount
);

export const selectBillingAddressCount = createSelector(
  [selectDomain],
  (state) => state.billingAddressCount
);
